import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  getBgMaster,
  getPlantMaster,
  listBgMasters,
  listPlantMasters,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import type { QueryKey } from '@tanstack/react-query'

/**
 * 電源ユニットの登録・更新・削除で値が変わる、導出値を持つ query。
 * 系統コードの電源種別は配下のユニットから、発電 BG の電源種別は所属する系統コードのユニットから決まる
 * (電源ユニットマスタ 2b)。ユニットを保存しても、これらを取り直さないと広域機関画面 (系統コード・BG の
 * 一覧、ダイアログ、CSV) が古い電源種別のまま残る。
 */
export function plantUnitDerivedQueryKeys(): QueryKey[] {
  return [
    createConnectQueryKey({ schema: listPlantMasters, cardinality: 'finite' }),
    createConnectQueryKey({ schema: getPlantMaster, cardinality: 'finite' }),
    createConnectQueryKey({ schema: listBgMasters, cardinality: 'finite' }),
    createConnectQueryKey({ schema: getBgMaster, cardinality: 'finite' }),
  ]
}
